define((require) => {
    "use strict";

    var Marionette                = require("marionette"),
        ShareRecipientDisplayView = require("ui/share/ShareRecipientDisplayView");

    /**
     * The collection view of share recipients for display purposes.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientDisplayCollectionView
     * @constructor
     */
    return Marionette.CompositeView.extend({
        template: function() { return ""; },
        itemView: ShareRecipientDisplayView
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareRecipientDisplayCollectionView.js